"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonLink = exports.Link = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const LinkContext_1 = require("./LinkContext");
const material_1 = require("@mui/material");
exports.Link = react_1.default.forwardRef(function Link(props, ref) {
    const LinkAdapter = (0, LinkContext_1.useLink)();
    if (LinkAdapter) {
        return (0, jsx_runtime_1.jsx)(material_1.Link, Object.assign({ ref: ref, component: LinkAdapter }, props));
    }
    return (0, jsx_runtime_1.jsx)(material_1.Link, Object.assign({ component: "a", ref: ref }, props));
});
function ButtonLink(props) {
    const LinkAdapter = (0, LinkContext_1.useLink)();
    if (LinkAdapter) {
        return (0, jsx_runtime_1.jsx)(material_1.Button, Object.assign({ component: LinkAdapter }, props));
    }
    return (0, jsx_runtime_1.jsx)(material_1.Button, Object.assign({}, props));
}
exports.ButtonLink = ButtonLink;
exports.default = exports.Link;
